var map = {
	"./azul.png": "c94d",
	"./b2b.png": "0a3a",
	"./gol.png": "1460",
	"./hotelbeds.png": "0e6b9",
	"./movida.png": "98c7",
	"./omnibees.png": "580c",
	"./rapid.png": "5624",
	"./sabre.png": "759b",
	"./travelport.png": "e329"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "267a";